(() => {
  const SELECTOR = '.palatore-variant-picker';

  const parseSeries = (model) => {
    const value = String(model).trim();
    const match = value.match(/(?:iphone\s*)?(\d{1,2}(?:\s*(?:pro|max|plus|mini|air))?)/i);
    return match ? match[1].match(/^\d{1,2}/)[0] : value.split(/\s+/)[0];
  };

  const shortModelName = (model, series) => {
    const shortened = String(model)
      .replace(/iphone/gi, '')
      .replace(new RegExp(`^\\s*${series}\\s*`, 'i'), '')
      .trim();
    return shortened || `iPhone ${series}`;
  };

  const init = (root) => {
    if (!root || root.dataset.palatoreReady === 'true') return;
    root.dataset.palatoreReady = 'true';

    const variantsNode = root.querySelector('[data-palatore-variants]');
    const nativeSelects = [...root.querySelectorAll('[data-palatore-native-option]')];
    if (!variantsNode || !nativeSelects.length) return;

    let variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      console.error('No se pudieron cargar las variantes de Palatore.', error);
      return;
    }

    const modelIndex = Number(root.dataset.modelIndex);
    const colorIndex = Number(root.dataset.colorIndex);
    const modelSelect = nativeSelects[modelIndex];
    const colorSelect = nativeSelects[colorIndex];
    const summary = root.querySelector('.palatore-model-picker__summary');
    const panel = root.querySelector('.palatore-model-picker__panel');
    const currentModel = root.querySelector('.palatore-model-picker__current');
    const currentColor = root.querySelector('.palatore-variant-picker__selected-color');
    const seriesContainer = root.querySelector('[data-palatore-series]');
    const currentSeries = root.querySelector('[data-palatore-current-series]');
    const modelButtons = [...root.querySelectorAll('[data-palatore-model]')];
    const colorButtons = [...root.querySelectorAll('[data-palatore-color]')];
    const swatchContainer = root.querySelector('.palatore-variant-picker__swatches');
    let swatchesExpanded = false;
    let moreButton;
    const formId = nativeSelects[0].getAttribute('form');
    const productForm = formId ? document.getElementById(formId) : null;
    const variantInput = productForm?.querySelector('input[name="id"]');
    const submitButton = productForm?.querySelector('button[type="submit"][name="add"]');
    const submitLabel = submitButton?.querySelector('.main-atc__label__line-1, .main-atc__label__text, span');
    const originalSubmitLabel = submitLabel?.textContent;

    const selections = () => nativeSelects.map((select) => select.value);
    const matches = (variant, values, ignoredIndex = -1) =>
      values.every((value, index) => index === ignoredIndex || variant.options[index] === value);

    const hasAvailableVariant = (optionIndex, optionValue) => {
      const values = selections();
      values[optionIndex] = optionValue;
      return variants.some((variant) => variant.available && matches(variant, values));
    };

    const selectedVariant = () => {
      const values = selections();
      return variants.find((variant) => matches(variant, values));
    };

    const activateMedia = (variant) => {
      const mediaId = variant?.featured_media?.id;
      if (!mediaId) return;
      const gallery = document.getElementById(`MediaGallery-${root.dataset.section}`);
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(`${root.dataset.section}-${mediaId}`, true);
        return;
      }
      document.querySelector(`[data-target="${root.dataset.section}-${mediaId}"] .thumbnail`)?.click();
    };

    const applyVariantChange = () => {
      const variant = selectedVariant();
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
      }

      if (submitButton) submitButton.disabled = !variant.available;
      if (submitLabel) {
        submitLabel.textContent = variant.available ? originalSubmitLabel : 'Agotado';
      }

      activateMedia(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      root.dispatchEvent(new CustomEvent('palatore:variant-change', {
        bubbles: true,
        detail: { variant },
      }));
    };

    const ensureValidColor = () => {
      if (!colorSelect) return;
      const values = selections();
      const exactExists = variants.some((variant) => matches(variant, values));
      if (exactExists) return;

      const replacement = variants.find(
        (variant) => variant.options[modelIndex] === values[modelIndex] && variant.available
      ) || variants.find((variant) => variant.options[modelIndex] === values[modelIndex]);

      if (replacement) colorSelect.value = replacement.options[colorIndex];
    };

    const preferredColorFor = (model) =>
      /^iphone\s*18\s*pro(?:\s*max)?$/i.test(String(model).trim()) ? 'Borgoña/Vino' : 'Naranja';

    const applyPreferredColor = (model) => {
      if (!colorSelect) return;
      const preferredColor = preferredColorFor(model);
      const optionExists = [...colorSelect.options].some((option) => option.value === preferredColor);
      const combinationExists = variants.some(
        (variant) =>
          variant.options[modelIndex] === model &&
          variant.options[colorIndex] === preferredColor
      );
      if (optionExists && combinationExists) colorSelect.value = preferredColor;
    };

    const layoutSwatches = () => {
      if (!swatchContainer || !moreButton) return;
      const visible = colorButtons.filter((button) => button.dataset.unavailable !== 'true');

      if (swatchesExpanded) {
        colorButtons.forEach((button) => button.classList.remove('is-collapsed'));
        moreButton.classList.remove('is-visible');
        swatchContainer.classList.add('is-expanded');
        return;
      }

      swatchContainer.classList.remove('is-expanded');
      colorButtons.forEach((button) => button.classList.remove('is-collapsed'));
      const sample = visible[0] || colorButtons[0];
      const size = sample ? (sample.getBoundingClientRect().width || 64) : 64;
      const gap = parseFloat(getComputedStyle(swatchContainer).gap) || 8;
      const fit = Math.max(1, Math.floor((swatchContainer.clientWidth + gap) / (size + gap)));

      if (visible.length <= fit) {
        moreButton.classList.remove('is-visible');
        return;
      }

      const slots = Math.max(1, fit - 1);
      const shown = visible.slice(0, slots);
      const active = visible.find((button) => button.classList.contains('is-active'));
      if (active && !shown.includes(active)) shown[slots - 1] = active;

      visible.forEach((button) => button.classList.toggle('is-collapsed', !shown.includes(button)));
      const remaining = visible.length - shown.length;
      moreButton.innerHTML = `<strong>+${remaining}</strong><small>${remaining === 1 ? 'más' : 'más'}</small>`;
      moreButton.classList.add('is-visible');
    };

    const render = () => {
      const values = selections();
      const selectedModel = modelSelect ? modelSelect.value : '';
      const selectedColor = colorSelect ? colorSelect.value : '';
      const selectedSeries = parseSeries(selectedModel);

      if (currentModel) currentModel.textContent = selectedModel;
      if (currentColor) currentColor.textContent = selectedColor;
      if (currentSeries) currentSeries.textContent = selectedSeries ? `iPhone ${selectedSeries}` : '';

      modelButtons.forEach((button) => {
        const value = button.dataset.palatoreModel;
        const buttonSeries = parseSeries(value);
        const active = value === selectedModel;
        button.hidden = buttonSeries !== selectedSeries;
        button.classList.toggle('is-active', active);
        button.classList.toggle('is-unavailable', !variants.some((variant) => variant.available && variant.options[modelIndex] === value));
        button.setAttribute('aria-pressed', String(active));
        const label = button.querySelector('[data-palatore-model-label]');
        if (label) label.textContent = shortModelName(value, buttonSeries);
      });

      root.querySelectorAll('[data-palatore-series-button]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.palatoreSeriesButton === selectedSeries);
      });

      const colorAvailability = colorButtons.map((button) => ({
        button,
        available: hasAvailableVariant(colorIndex, button.dataset.palatoreColor),
      }));
      const hasAnyAvailableColor = colorAvailability.some((item) => item.available);

      colorAvailability.forEach(({ button, available }) => {
        const value = button.dataset.palatoreColor;
        const active = value === selectedColor;
        button.classList.toggle('is-active', active);
        button.classList.toggle('is-unavailable', !available);
        button.dataset.unavailable = hasAnyAvailableColor && !available ? 'true' : 'false';
        button.setAttribute('aria-pressed', String(active));
      });

      root.querySelectorAll('[data-palatore-extra-option]').forEach((select) => {
        const index = Number(select.dataset.palatoreExtraOption);
        select.value = values[index];
      });

      requestAnimationFrame(layoutSwatches);
    };

    if (swatchContainer) {
      moreButton = document.createElement('button');
      moreButton.type = 'button';
      moreButton.className = 'palatore-variant-picker__swatch-more';
      moreButton.setAttribute('aria-label', 'Ver todos los colores');
      moreButton.addEventListener('click', () => {
        swatchesExpanded = true;
        layoutSwatches();
      });
      swatchContainer.appendChild(moreButton);
    }

    if (modelSelect && seriesContainer) {
      const series = [...new Set([...modelSelect.options].map((option) => parseSeries(option.value)))].sort(
        (a, b) => Number(b) - Number(a)
      );
      seriesContainer.replaceChildren(
        ...series.map((name) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'palatore-model-picker__series-button';
          button.dataset.palatoreSeriesButton = name;
          button.textContent = name;
          button.addEventListener('click', () => {
            const firstModel = modelButtons.find((item) => parseSeries(item.dataset.palatoreModel) === name);
            if (!firstModel) return;
            modelSelect.value = firstModel.dataset.palatoreModel;
            applyPreferredColor(modelSelect.value);
            ensureValidColor();
            applyVariantChange();
            render();
          });
          return button;
        })
      );
    }

    summary?.addEventListener('click', () => {
      const willOpen = panel.hidden;
      panel.hidden = !willOpen;
      summary.setAttribute('aria-expanded', String(willOpen));
    });

    modelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        modelSelect.value = button.dataset.palatoreModel;
        applyPreferredColor(modelSelect.value);
        ensureValidColor();
        applyVariantChange();
        panel.hidden = true;
        summary?.setAttribute('aria-expanded', 'false');
        render();
      });
    });

    colorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        colorSelect.value = button.dataset.palatoreColor;
        applyVariantChange();
        render();
      });
    });

    root.querySelectorAll('[data-palatore-extra-option]').forEach((select) => {
      select.addEventListener('change', () => {
        const nativeSelect = nativeSelects[Number(select.dataset.palatoreExtraOption)];
        nativeSelect.value = select.value;
        applyVariantChange();
        render();
      });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutSwatches, 120);
    });

    if (modelSelect && !new URL(window.location.href).searchParams.has('variant')) {
      applyPreferredColor(modelSelect.value);
      ensureValidColor();
    }

    applyVariantChange();
    render();
  };

  const initAll = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
